import { render, staticRenderFns } from "./contentstatistics.vue?vue&type=template&id=03cdec53&scoped=true&"
import script from "./contentstatistics.vue?vue&type=script&lang=js&"
export * from "./contentstatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cdec53",
  null
  
)

export default component.exports